import { render } from "./BtnSubmit.vue?vue&type=template&id=25c2495e"
import script from "./BtnSubmit.vue?vue&type=script&lang=js"
export * from "./BtnSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__